<template>
  <div>
      <div class="main" style="background-image:url(static/img/act/10/banner/bg.jpg)" >
        <div class="act-10-center-wrap" style="background-image: url(static/img/act/10/banner/line.png)">      
          <div class="act-10-banner-wrap"  >
            <img class="act-10-banner-liuzhou " v-bind:class="{'act-10-animation-liuzhou':isTitleShow}" src="static/img/act/10/banner/liuzhou.png">
            <img class="act-10-banner-title"  v-bind:class="{'act-10-animation-title':isTitleShow}"  v-bind:style="{'top':titleTop}" src="static/img/act/10/banner/title.png">  
          </div>
          <router-link :to="{ path: '/act10/newslist', query: { type: 1 , cid: 200, idArray: '73684,73543,72987,72679,73187,60904,73184,72184'}}">
            <img class="act-10-banner-btn-go act-10-animation-btn-go" src="static/img/act/10/banner/btn.png"> 
          </router-link>           
        </div>
        <img class="act-10-banner-ship" v-bind:class="{'act-10-animation-ship-line':isShipShow}" src="static/img/act/10/banner/ship.png">        
        <img class="act-10-banner-flower-1" src="static/img/act/10/banner/flower-1.png">
        <img class="act-10-banner-flower-2" src="static/img/act/10/banner/flower-2.png">
        <img class="act-10-banner-flower-3" src="static/img/act/10/banner/flower-3.png">
        <img class="act-10-banner-flower-4" src="static/img/act/10/banner/flower-4.png">
      </div>
  </div>
</template>
 

<script>
export default {
  name: "Act10Banner",
  data() {
    return {
      isTitleShow:false,
      isShipShow:false,
    };
  },
  computed:{
    titleTop() {       
      if(document.documentElement.clientWidth/document.documentElement.clientHeight < 0.51){
        return '126%';
      } else{
        console.log("noset")
      }
    }
  },
  mounted() {
  },
  created() {    
    var s = 2100;
    if(this.$route.fullPath.indexOf('/act10') > -1 ){
      s = 2100;
    }else{
      s = 1000;
    }
    let vm = this
    //移除loading
    if(this.removeLoader()){
      setTimeout(function(){
        vm.isTitleShow = true
        vm.isShipShow = true
      },s)
    }else{
      setTimeout(function(){
        vm.isTitleShow = true
        vm.isShipShow = true
      },100)
    }
    this.setDocumentV2(
      "古砦秋趣",
      "",
      "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/10/share.jpg?v=2"
    );
    _czc.push(['_trackEvent', '古砦秋趣', '点击', 'Banner页面','0','10']);  
  },
  methods: { 
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {  
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  height: calc(100% - 1.37rem);
  background-position: 50% !important;
  background-size: cover !important;
  overflow: hidden;
}
.act-10-center-wrap {
    position: absolute;
    top: 8%;
    left: 8%;
    width: 84%;
    height: 84%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
}
 

.act-10-banner-ship{
    position: absolute;
    top: 100%;
    left: 29%;
    width: 44%;
    max-width: 100%;
} 


@keyframes act-10-frames-ship-line {
  0% { 
    -webkit-transform: translateY(0%)  translateX(0%);
    transform: translateY(0%)  translateX(0%);
  } 
  100% {
    -webkit-transform: translateY(-150%)  translateX(96%) rotate(-180deg);;
    -webkit-transform-origin: center center;
    -moz-transform:  translateY(-150%)  translateX(96%) rotate(-180deg);;
    -moz-transform-origin: center center;
    transform:  translateY(-150%)  translateX(96%) rotate(-180deg);;
    transform-origin: center center;
  }
}

.act-10-animation-ship-line {  
  animation-name: act-10-frames-ship-line 3s both;
  -webkit-animation: act-10-frames-ship-line 3s both;
  -moz-animation: act-10-frames-ship-line 3s both;
  animation: act-10-frames-ship-line 3s both;
  animation-delay: 500ms;
  -webkit-animation-delay: 500ms;
}
 

@-webkit-keyframes act-10-frames-animation-ship {
  0% {
    -webkit-transform:translateY(-150%)  translateX(96%)   rotate(0deg);
    -webkit-transform-origin: center center;
    -moz-transform:translateY(-150%)  translateX(96%)   rotate(0deg);
    -moz-transform-origin: center center;
    transform:translateY(-150%)  translateX(96%)   rotate(0deg);
    transform-origin: center center;
  }
  20% {
    -webkit-transform: translateY(-150%)  translateX(96%)  rotate(6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-150%)  translateX(96%)  rotate(6deg);
    -moz-transform-origin: center center;
    transform:  translateY(-150%)  translateX(96%) rotate(6deg);
    transform-origin: center center;
  }
  40% {
    -webkit-transform: translateY(-150%)  translateX(96%)  rotate(-6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-150%)  translateX(96%)  rotate(-6deg);
    -moz-transform-origin: center center;
    transform: translateY(-150%)  translateX(96%)  rotate(-6deg);
    transform-origin: center center;
  }
  60% {
    -webkit-transform: translateY(-150%)  translateX(96%)  rotate(6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-150%)  translateX(96%)  rotate(6deg);
    -moz-transform-origin: center center;
    transform:  translateY(-150%)  translateX(96%)  rotate(6deg);
    transform-origin: center center;
  }
  80% {
    -webkit-transform: translateY(-150%)  translateX(96%)  rotate(-6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-150%)  translateX(96%)  rotate(-6deg);
    -moz-transform-origin: center center;
    transform: translateY(-150%)  translateX(96%)  rotate(-6deg);
    transform-origin: center center;
  }
  100% {
    -webkit-transform: translateY(-150%)  translateX(96%)  rotate(6deg);
    -webkit-transform-origin: center center;
    -moz-transform: translateY(-150%)  translateX(96%)  rotate(6deg);
    -moz-transform-origin: center center;
    transform: translateY(-150%)  translateX(96%)  rotate(6deg);
    transform-origin: center center;
  }
}

@keyframes act-10-frames-animation-ship {
  0% {
    -webkit-transform:  translateY(-150%)  translateX(96%) rotate(0deg);
    -webkit-transform-origin: center center;
    transform:  translateY(-150%)  translateX(96%) rotate(0deg);
    transform-origin: center center;
  }
  20% {
    -webkit-transform: translateY(-150%)  translateX(96%)  rotate(6deg);
    -webkit-transform-origin: center center;
    transform: translateY(-150%)  translateX(96%)  rotate(6deg);
    transform-origin: center center;
  }
  40% {
    -webkit-transform: translateY(-150%)  translateX(96%)  rotate(-6deg);
    -webkit-transform-origin: center center;
    transform:  translateY(-150%)  translateX(96%) rotate(-6deg);
    transform-origin: center center;
  }
  60% {
    -webkit-transform:  translateY(-150%)  translateX(96%) rotate(6deg);
    -webkit-transform-origin: center center;
    transform:  translateY(-150%)  translateX(96%) rotate(6deg);
    transform-origin: center center;
  }
  80% {
    -webkit-transform: translateY(-150%)  translateX(96%)  rotate(-6deg);
    -webkit-transform-origin: center center;
    transform: translateY(-150%)  translateX(96%)  rotate(-6deg);
    transform-origin: center center;
  }
  100% {
    -webkit-transform:  translateY(-150%)  translateX(96%) rotate(6deg);
    -webkit-transform-origin: center center;
    transform:  translateY(-150%)  translateX(96%) rotate(6deg);
    transform-origin: center center;
  }
}
 

@-webkit-keyframes act-10-fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes act-10-fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.act-10-animation-liuzhou {
  -webkit-animation-name: act-10-fadeIn;
  animation-name: act-10-fadeIn;
  -webkit-animation: act-10-fadeIn 0.5s ease-in-out both;
  -moz-animation: act-10-fadeIn 0.5s ease-in-out both;
  animation: act-10-fadeIn 0.5s ease-in-out both; 
}

.act-10-banner-wrap{
    position: absolute;
    top: 13%;
    left: 27%;
    width: 45%;

}
.act-10-banner-liuzhou{   
    width: 100%;
    max-width: 100%;
    opacity: 0;
} 

  


.act-10-animation-title {
  -webkit-animation-name: act-10-fadeIn;
  animation-name: act-10-fadeIn;
  -webkit-animation: act-10-fadeIn 0.8s ease-in-out both;
  -moz-animation: act-10-fadeIn 0.8s ease-in-out both;
  animation: act-10-fadeIn 0.8s ease-in-out both;
  animation-delay: 500ms;
  -webkit-animation-delay: 500ms;
}

.act-10-banner-title{
    position: absolute;
    top: 102%;
    left: -43%;
    width: 124%;
    opacity: 0;
} 


   
 
/* 按钮 */
@keyframes act-10-frames-btn-go {
  0% { 
    -webkit-transform: scale(1);
    transform:  scale(1);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  }
  50% {
    -webkit-transform: scale(0.9);
    transform:  scale(0.9);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  }
  100% { 
    -webkit-transform: scale(1);
    transform:  scale(1);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  }
}


.act-10-animation-btn-go {
  -webkit-animation-name: act-10-frames-btn-go;
  animation-name: act-10-frames-btn-go;
  -webkit-animation: act-10-frames-btn-go 2s ease-in-out infinite;
  -moz-animation: act-10-frames-btn-go 2s ease-in-out infinite;
  animation: act-10-frames-btn-go 2s ease-in-out infinite;
}

.act-10-banner-btn-go{    
    position: absolute;
    top: 79%;
    left: 38%;
    width: 23%;
    max-width: 100%;
    z-index: 2;
} 

/* 按钮 end */

.act-10-banner-flower-1 {
  position: absolute;
  top:0;
  left:0;
  width: 66%;
}

.act-10-banner-flower-2 {
  position: absolute;
  top:0;
  right:0;
  width: 100%;
}

.act-10-banner-flower-3 {
  position: absolute;
  bottom:0;
  left:0;
  width: 30%;
}
.act-10-banner-flower-4 {
  position: absolute;
  bottom:0;
  right:0;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/act/10/Banner.vue